<template>
  <div>
    <VTableLocal
      v-if="orderProducts"
      customClass="deepTable"
      :iconHeader="null"
      :items="orderProducts"
      :isSearchable="false"
      :isSelectable="false"
      :disablePagination="true"
      :headers="tableHeaders"
      :centerColumns="['action', 'quantity']"
      :showRowIcon="false"
      :isCustomIconNext="true"
    >
      <template #item="{item}">
        <tr>
          <td class="text-start w-column">
            {{ item.productName }}
          </td>
          <td class="text-start w-column">
            {{ item.location }}
          </td>
          <td class="text-start w-column">
            {{ item.container }}
          </td>
          <td>
            <div class="q-style w-qte">
              <VTextField
                v-model="item.quantity"
                solo
                flat
                min="0"
                type="number"
                extraClass="quantityProduct"
                :rules="{ min: 0, max: 5 }"
                :disabled="order.status === 'Sent'"
                persistentHint
                @blur="updateProductQuantity(item)"
              />
            </div>
          </td>
          <td class="w-column">
            <div class="q-style">
              <VTableAction
                v-if="getItemActions"
                :itemActions="getItemActions"
                @iconAction="onClickAction(item, getItemActions[0])"
              />
            </div>
          </td>
        </tr>
      </template>
    </VTableLocal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import VTableAction from '@/components/shared/widgets/VTableAction.vue';

export default {
    components: {
        VTableAction,
        VTableLocal,
        VTextField,
    },
    props: {
        products: {
            type: Array,
            default: () => [],
        },
        orderId: {
            type: String,
            default: '',
        },
        siteId: {
            type: String,
            default: '',
        },
        order: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            orderProducts: cloneDeep(this.products), // we need a copy of the object to be able to mutate some props(quantity).
        };
    },
    computed: {
        tableHeaders() {
            const header = [
                {
                    text: this.$t('forms.labels.product'),
                    value: 'productName',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.location'),
                    value: 'location',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.container'),
                    value: 'container',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.quantity'),
                    value: 'quantity',
                    sortable: false,
                },
                {
                    text: this.getItemActions ? this.$t('forms.labels.actions') : '',
                    value: 'action',
                    sortable: false,
                },
            ];

            return header;
        },
        getItemActions() {
            if (this.order.status === 'Sent') return undefined;
            const actions = [];
            actions.push({
                name: this.$t('forms.labels.delete'),
                icon: 'delete',
                iconAndTextColor: '#EF4135',
            });
            return actions;
        },
    },

    watch: {
        products: {
            handler() {
                this.orderProducts = cloneDeep(this.products);
            },
            deep: true,
        },
    },
    created() {
    },
    methods: {
        ...mapActions({
            reloadOrders: 'getOrderItems',
        }),
        onClickAction(item, action) {
            switch (action.icon) {
                case 'delete':
                    this.deleteProductFromOrder(item);
                    break;
                default:
                    break;
            }
        },
        async deleteProductFromOrder(item) {
            await this.$rq.deleteProductFromOrder(this.siteId, this.orderId, item.id);
            this.$toasted.global.toast_success({
                message: this.$t('generic.deleted'),
            });
            this.reloadOrders({ siteId: this.siteId });
        },
        async updateProductQuantity(item) {
            const currentItem = this.products.find(p => p.id === item.id);
            if (currentItem.quantity !== parseInt(item.quantity, 10)) {
                const { data } = await this.$rq.addItemToOrder(this.siteId, { ...item });
                if (data?.id) {
                    this.reloadOrders({ siteId: this.siteId });
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.w-column {
    width: 250px;
}
.w-qte{
    width: 100%;
}
.q-style {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
